// @ts-check

import React from 'react';
import { func, object, string } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import Grid from '@mui/material/Grid';
import ProfilePaper from './ProfilePaper';
import Typography from '@mui/material/Typography';
import ProfileEditorPwdField from './ProfileEditorPwdField';

/**
 * @component ProfileEditorChangePassword
 * @param {Object} props
 * @param {string} props.pwd
 * @param {EditorValidType} props.pwdValid
 * @param {string} props.confirmPwd
 * @param {EditorValidType} props.confirmPwdValid
 * @param {(name:string, payload:any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorChangePassword({ pwd, pwdValid, confirmPwd, confirmPwdValid, onHandle }) {
	return (
		<ProfilePaper>
			<Typography variant="button">CHANGE PASSWORD</Typography>
			<Typography variant="caption" display="block" gutterBottom>
				Only enter the password if you need to update it, otherwise leave it empty.
			</Typography>
			<Grid container spacing={2}>
				<Grid item lg={6} xs={12}>
					<ProfileEditorPwdField
						label="Password"
						name={USER.PASSWORD}
						size="small"
						value={pwd}
						valid={pwdValid}
						onHandle={onHandle}
					/>
				</Grid>
				<Grid item lg={6} xs={12}>
					<ProfileEditorPwdField
						label="Confirm Password"
						name={USER.CONFIRM_PASSWORD}
						size="small"
						value={confirmPwd}
						valid={confirmPwdValid}
						onHandle={onHandle}
					/>
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfileEditorChangePassword.propTypes = {
	pwd: string,
	pwdValid: object,
	confirmPwd: string,
	confirmPwdValid: object,
	onHandle: func,
};

export default ProfileEditorChangePassword;
